import { render, staticRenderFns } from "./record.vue?vue&type=template&id=b179f240&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b179f240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b179f240')) {
      api.createRecord('b179f240', component.options)
    } else {
      api.reload('b179f240', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=b179f240&scoped=true", function () {
      api.rerender('b179f240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/record.vue"
export default component.exports